/**
 * ApActionType
 *
 * @hidden
 * Should match server enum found at EE.Api/Entities/ApActionType.cs
 *
 * TIP: text values used as value's label when displayed in components
 */
export enum ApActionType {
    task = 'Task',
    sms = 'SMS',
    email = 'Email',
    voicemail = 'Voicemail',
    picture = 'Picture',
    video = 'Video',
    displayEvent = 'DisplayEvent',
}
